import React from 'react'; 
import './Footer.scss';
import emailImg from '../img/email.svg'
import twitterImg from '../img/twitter.svg'
import youtubeImg from '../img/youtube.svg'

function Footer(props){
	return (
		<div className="footerContainer"> 
			<div className="imgContainer">
				<a target="_blank" rel="noopener noreferrer" href="https://agro.basf.ca/basf_solutions/index/contact_west.html"><img src={emailImg} alt="email" /></a>
				<a target="_blank" rel="noopener noreferrer" href="https://twitter.com/basfagsolutions"><img src={twitterImg} alt="twitter" /></a>
				<a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/user/BASFAgSolutions"><img src={youtubeImg} alt="youtube" /></a>
			</div> 
			<div className="text">Always read and follow label directions</div>
			<div className="footerBottom">
				<span>© 2026 BASF Agricultural Solutions Canada Inc. All rights reserved.</span>
				<a target="_blank" rel="noopener noreferrer" href="https://www.basf.com/ca/en/legal/disclaimer.html">Disclaimer</a>
				<a target="_blank" rel="noopener noreferrer" href="https://www.basf.com/ca/en/legal/credits.html">Credits</a>
				<a target="_blank" rel="noopener noreferrer" href="https://www.basf.com/ca/en/legal/data-protection.html">Privacy Policy</a>
				<a target="_blank" rel="noopener noreferrer" href="https://agro.basf.ca/basf_solutions/index/contact_west.html">Contact</a>
			</div>
		</div>
	)
}

export default Footer;